module.exports = __webpack_public_path__ + "src/img/galerie/aussenrenovierung/Aussenfassade-Nachher.jpg";